<template>
  <div id="app" ref="app">
    <router-view />
  </div>
</template>
<script>
	export default {
    computed:{
      
      // key(){
        // return this.$route+ +new Date()
      // }
    },
	}
</script>
<style lang="scss">
</style>
